export class NewUserTo {
    id: bigint
    email: string
    firstName: string
    lastName: string
    phone: string
    psapId: string
    issuerAssignedId: bigint
    signedUp : bigint
    constructor(object?: any) {
        this.id = object.id
        this.email = object.email
        this.firstName = object.firstName
        this.lastName = object.lastName
        this.psapId = object.psapId
        this.issuerAssignedId = object.issuerAssignedId
        this.signedUp = object.signedUp
        this.phone = object.phone
    }
}
